module.exports = __webpack_public_path__ + "img/434.8f1a32cc.png";